import React from 'react';

export interface SocialLinkItem {
  network: string;
  url: string;
  label: string;
}

interface SocialLinksProps {
  socialLinks?: SocialLinkItem[];
  socialLinksTitle?: string;
}

function SocialLinks({
  socialLinks,
  socialLinksTitle,
}: SocialLinksProps): React.ReactElement | null {
  if (!socialLinks || socialLinks.length === 0) {
    return null;
  }

  return (
    <nav className="socialLinks" aria-label="Social links">
      {socialLinksTitle && (
        <h3 className="socialLinks__title">{socialLinksTitle}</h3>
      )}
      <ul className="socialLinks__links">
        {socialLinks.map((item) => (
          <li key={item.url} className="socialLinks__linkItem">
            <a
              className={`socialLinks__link socialLinks__link--${item.network.toLowerCase()}`}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={item.label}
            >
              <span className="socialLinks__linkText">{item.label}</span>
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default SocialLinks;
